import React from 'react';
import { Input, Button, Tooltip } from '@heroui/react';
import { FilterSelect, ResponsiveTooltip } from '../../../../components/ui';
import { SearchInputIc, ResetFiltersIc } from '../../../../components/icons';
import { useTranslations } from '../../../../contexts/translation.context';
import { FiltersProps } from '../types';
import { getSortOptions, getTypeOptions } from '../constants';

const FiltersSection: React.FC<FiltersProps> = ({
  filters,
  localSearch,
  hasActiveFilters,
  onSearchChange,
  onFilterChange,
  onResetFilters,
}) => {
  const { t } = useTranslations();

  return (
    <div className="pb-6 flex items-center gap-4 flex-wrap justify-between w-full">
      <div className="flex items-center gap-4 md:flex-wrap md:justify-start max-md:h-10 [&>*]:shrink-0 max-md:overflow-x-auto max-md:px-4 max-md:-mx-4 scroller-none">
        <Input
          type="text"
          placeholder={t('revshare.offers.filters.searchPlaceholder')}
          size="sm"
          value={localSearch}
          onChange={(e) => onSearchChange(e.target.value)}
          endContent={<SearchInputIc />}
          classNames={{
            mainWrapper: 'w-[17.0625rem]',
            base: 'w-[17.0625rem]',
            input: 'text-sm',
            inputWrapper: 'rounded-lg h-9 w-[17.0625rem]',
          }}
        />

        <FilterSelect
          placeholder={t('revshare.offers.filters.sorting')}
          options={getSortOptions(t)}
          selectedKey={filters.sortBy === 'all' ? undefined : filters.sortBy}
          variant="campaign"
          onSelectionChange={(value) => onFilterChange('sortBy', value || 'all')}
          startContent={
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path
                fill="none"
                stroke="#A8A8B0"
                strokeLinecap="round"
                strokeWidth="1.5"
                d="M22 7H2m17 5H5m11 5H8"
              />
            </svg>
          }
          autoWidth={true}
        />

        {/* <FilterSelect
          placeholder={t('revshare.offers.filters.campaignType') || 'Тип кампании'}
          options={getTypeOptions(t).filter(opt => opt.key !== 'all')}
          selectedKey={filters.type === 'all' ? undefined : filters.type}
          variant="campaign"
          onSelectionChange={(value) => onFilterChange('type', value || 'all')}
          autoWidth={true}
        /> */}

        {!hasActiveFilters && <div className="shrink-0 w-10 h-2 md:hidden"></div>}

        {hasActiveFilters && (
          <Tooltip content={t('revshare.offers.filters.resetTooltip')} placement="top">
            <Button
              //@ts-ignore
              size="xs"
              className="h-9 rounded-2 !w-9 p-0 bg-auth-surface shrink-0"
              onPress={onResetFilters}
            >
              <ResetFiltersIc />
            </Button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default FiltersSection;
